import { useActiveAccount } from "thirdweb/react";
import { useAuthStore } from "../../stores/useAuthStore.js";
// Wrapper around useActiveAccount
export const useB3Account = () => {
  const isAuthenticated = useAuthStore(_temp);
  const activeAccount = useActiveAccount();
  const effectiveAccount = isAuthenticated ? activeAccount : undefined;
  return effectiveAccount;
};
function _temp(state) {
  return state.isAuthenticated;
}